module.exports = __webpack_public_path__ + "static/media/diamond.462e2954.png";